<template>
  <div class="h-dialogContainer">
    <div class="row h-row-inputBox">
      <div class="col-sm-7 h-col-inputBox">
        <div class='h-inputLit'>
          <span>{{$t('MCS.userNum')}}</span>
        </div>
        <input class="e-input" :value='userNum' disabled="true"/>
      </div>
    </div>
    <br>
    <div class="h-borderBox" style="height: 420px">
      <!--<div class="h-dialog-borderBox-topIcon">-->
        <!--<div class="h-toolbarBg dialog-icon-style">-->
          <!--<ejs-toolbar class="dialog-icon-style">-->
            <!--<div class="dialog-icon-style">-->
              <!--<div>-->
                <!--<button :title='$t("MCS.add")' class="e-tbar-btn e-control e-btn e-lib e-icon-btn dialog-icon-style"-->
                        <!--data-ripple="true" tabindex="-1" @click='addArea'>-->
                  <!--<span class="e-btn-icon icon hero-icon hero-icon-save e-icons"></span>-->
                <!--</button>-->
              <!--</div>-->
            <!--</div>-->
          <!--</ejs-toolbar>-->
        <!--</div>-->
      <!--</div>-->
      <div class="h-dialog-borderBox-topIcon" style="padding: 0px;">
        <button :title='$t("MCS.add")' class="my-class e-btn e-tbar-btn icon hero-icon hero-icon-add-small"
                data-ripple="true" tabindex="-1" @click='addArea' style="margin: 5px 10px 5px 5px;float: right">
        </button>
      </div>
      <div class="h-borderBox-content" style="overflow: hidden">
        <ejs-grid ref='grid' :dataSource="data" height='100%' :allowReordering='true' :allowResizing='true'>
          <e-columns>
            <e-column type='checkbox' headerText='mcsid' width='50' textAlign='Center'></e-column>
            <e-column field='areaId' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.areaId")' width='20%'
                      textAlign='Center'></e-column>
            <e-column field='netType' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.netType")'
                      :formatter='netTypeFormat' width='20%'
                      textAlign='Center'></e-column>
            <e-column field='plmnId' clipMode='EllipsisWithTooltip' headerText='PLMN' width='20%'
                      textAlign='Center'></e-column>
            <e-column field='enbId' clipMode='EllipsisWithTooltip' headerText='eNB ID' width='20%'
                      textAlign='Center'></e-column>
            <e-column field='cellId' clipMode='EllipsisWithTooltip' headerText='Cell ID' width='20%'
                      textAlign='Center'></e-column>
            <e-column field='areaName' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.areaName")' width='20%'
                      textAlign='Center'></e-column>
            <e-column field='description' clipMode='EllipsisWithTooltip' :headerText='$t("MCS.description")' width='20%'
                      textAlign='Center'></e-column>
          </e-columns>
        </ejs-grid>
      </div>
    </div>
    <div>
      <ejs-pager @click='getGridData()' :pageSize='page.pageSize' :currentPage='page.pageNo'
                 :totalRecordsCount='page.totalCount' ref='pager'></ejs-pager>
    </div>
    <CustomDialog ref='dialogPage' :element='dialogTip' :styles='styles'>
      <template v-slot:dialog-content>
        <DialogList ref='dialog'></DialogList>
      </template>
    </CustomDialog>
  </div>
</template>

<script>

  import commonJS from '../../common';
  import DialogList from '../../../../subscriberconfig/util/tipDialog/DialogList';
  import CustomDialog from '../../../../common/CustomDialog';

  export default {
    name: 'AddAreaDialog',
    props: [
      'neid'
    ],
    components: {
      DialogList,
      CustomDialog
    },
    mixins: [commonJS],
    data() {
      return {
        data: {},
        userNum: '',
        mcsid: '',
        page: {
          pageNo: 1,
          pageSize: 100,
          totalCount: 0,
          pageCount: 0,
        },
        vo: {
          flag: '',
          participantType: ''
        },
        dialogTip: {
          target: this.$refs.grouptable,
          refName: 'dialogList',
          buttonGroup: [
            {
              click: this.closeDialogListTipPage,
              buttonModel: {content: this.$t('MCS.confirm')}
            }
          ],
          title: this.$t('MCS.messageInfo'),
          isClose: true,
        },
        gridTypeEnum: {
          netType: [, , '2G', '3G', '4G', '5G'],
        },
      };
    },
    methods: {
      getGridData(mcsid = this.mcsid, userNum = this.userNum) {
        const $this = this;
        this.userNum = userNum;
        this.mcsid = mcsid;
        const vo = {
          flag: 0,
          areaId: '',
          enterpriseDomain: $this.enterpriseDomain,
          productType: $this.productType,
          vpnId: $this.vpnId,
          vpnClass: $this.vpnClass,
        };
        const params = {
          info: {
            neid: $this.neid,
            msgid: this.msg.qryUserArea
          },
          vo: vo,
          page: {
            pageNo: $this.$refs.pager.ej2Instances.currentPage,
            pageSize: this.page.pageSize
          }
        };
        this.$axios.post(this.requestCommon, params).then((response) => {
          const res = response.data.resultVal;
          $this.data = res.result;
          $this.page.totalCount = res.totalCnt;
        });
      },

      closeDialogListTipPage() {
        this.$refs.dialogPage.clear();
        this.$refs.dialogPage.close();
      },

      getGridMCID() {
        const gridData = this.$refs.grid.getSelectedRecords();
        if (gridData.length === 0) {
          this.$toast('warning', this.$t('Common.tips.noSelect'))
          return null;
        }
        ;
        const mcsid = [];
        gridData.forEach((item) => {
          mcsid.push(item.mcsid);
        });
        return mcsid;
      },

      getGridAreaId() {
        const gridData = this.$refs.grid.getSelectedRecords();
        if (gridData.length === 0) {
          this.$toast('warning', this.$t('Common.tips.noSelect'));
          return null;
        }
        ;
        const areaId = [];
        gridData.forEach((item) => {
          areaId.push(item.areaId);
        });
        return areaId;
      },

      addArea() {
        const $this = this;
        const areaId = this.getGridAreaId();
        if (areaId === null) return;
        const userNum = [];
        this.$refs.grid.getSelectedRecords().forEach((item) => {
          userNum.push(item.userNum);
        });
        const params = {
          info: {
            neid: this.neid,
            msgid: this.msg.addAreaAuthorize,
            operation: 'addArea'
          },
          vo: {
            0: {
              vo: {
                enterpriseDomain: $this.enterpriseDomain,
                productType: $this.productType,
                userNum: $this.userNum,
                areaId: areaId
              },
              info: {
                neid: this.neid,
                msgid: this.msg.addAreaAuthorize,
                mcsFlag: true
              },
            }
          },
          log: {
            module: 'res.subscriber#res.subscriber_mcs#res.subscriber_mcs_user',
            execFunName: 'subscriber.mcsaddArea',
            exectype: 1,
            //execData: logArray
          }
        };
        const opCount = areaId.length;
        const resObj = [];
        for (let i = 0; i < opCount; i++) {
          const resData = {};
          resData.operObj = areaId[i];
          resObj.push(resData);
        }
        this.$loading.showLoadding(this.$t('MCS.addAreaNum'),this.$t('SubscriberIms.waitTip'));
        this.$axios.post(this.requestCommon, params).then((response) => {
          resObj.forEach((item, index) => {
            item.operResult = response.data.resultVal[index].code === "0" ? $this.$t('Common.tips.success') : response.data.resultVal[index].code;
            item.operCode = response.data.resultVal[index].code;
          });
          this.$refs.dialog.addOperetionResultList(resObj);
          this.$refs.dialog.setTotalCount(opCount);
          this.$refs.dialogPage.show();
          this.$loading.hideLoadding();
        });
      },
      netTypeFormat(grids, data) {
        return this.gridTypeEnum.netType[data.netType];
      },
    },
  };
</script>

<style scoped>
  .my-class.e-btn:active,.my-class.e-btn:focus{
    box-shadow: none !important;
  }

  .my-class{
    width: 30px;
    height: 30px;
    padding: 0px;
    color: #007bff;
    background-color: #e6f7ff;
    border: 0px;
  }
</style>
